import { StockPicker } from "@blocks/Blocks";

type AnnotationStockPickerProps = {
  /** Optional CSS class to apply to the component */
  className?: string;
  /** Optional children to render inside the StockPicker */
  children?: React.ReactNode;
  /** The stock code to be used in the StockPicker */
  stockCode: string;
};

/**
 * AnnotationStockPicker component that renders a StockPicker with the provided stock code.
 */
const AnnotationStockPicker = ({
  className,
  children,
  stockCode,
}: AnnotationStockPickerProps): React.ReactElement => {
  return (
    <>
      {typeof stockCode === "string" ? (
        <StockPicker code={stockCode} className={className}>
          {children}
        </StockPicker>
      ) : null}
    </>
  );
};

export default AnnotationStockPicker;
